import { useEffect, useState } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import { useLogout } from "../auth/useLogout";
import { Modal } from "./Modal";

const NAV_ITEMS = [
  { to: "/", label: "Dashboard", end: true },
  { to: "/content-types", label: "Content Types", end: false },
  { to: "/products", label: "Inventory", end: false },
  { to: "/media", label: "Media", end: false },
  { to: "/subscribers", label: "Subscribers", end: false },
  { to: "/settings/integrations", label: "Integrations", end: false },
] as const;

function Navigation({ onNavigate }: { onNavigate?: () => void }) {
  return <nav className="sidebar__nav" aria-label="Primary">
    {NAV_ITEMS.map((item) => <NavLink key={item.to} to={item.to} end={item.end} onClick={onNavigate}
      className={({ isActive }) => isActive ? "sidebar__link sidebar__link--active" : "sidebar__link"}>{item.label}</NavLink>)}
  </nav>;
}

export function Layout() {
  const auth = useAuth();
  const logout = useLogout();
  const location = useLocation();
  const [loggingOut, setLoggingOut] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const email = auth.email || "Signed in";
  const onLogout = () => { setLoggingOut(true); void logout(); };

  useEffect(() => { setMenuOpen(false); }, [location.key]);
  useEffect(() => {
    const desktop = window.matchMedia("(min-width: 961px)");
    const update = () => { if (desktop.matches) setMenuOpen(false); };
    desktop.addEventListener("change", update);
    return () => desktop.removeEventListener("change", update);
  }, []);

  return <div className="app-shell">
    <a className="app-skip" href="#main-content">Skip to content</a>
    <aside className="sidebar">
      <div className="sidebar__brand"><span className="sidebar__brand-mark" aria-hidden="true">E</span><span className="sidebar__brand-text">EAUB CMS</span></div>
      <Navigation />
      <div className="sidebar__footer">Enterprise Headless CMS</div>
    </aside>
    <div className="main-area">
      <header className="topbar">
        <span className="topbar__workspace">EAUB CMS</span>
        <div className="topbar__spacer" />
        <button type="button" className="btn btn--secondary topbar__menu" aria-haspopup="dialog"
          aria-expanded={menuOpen} aria-controls={menuOpen ? "admin-menu" : undefined} onClick={() => setMenuOpen(true)}>
          <span aria-hidden="true">☰</span> Menu
        </button>
        <div className="topbar__user">
          <span className="topbar__email" title={email}>{email}</span>
          <button type="button" className="btn btn--secondary btn--sm" onClick={onLogout} disabled={loggingOut}>{loggingOut ? "Logging out…" : "Logout"}</button>
        </div>
      </header>
      <main className="content" id="main-content" tabIndex={-1}><Outlet /></main>
    </div>
    {menuOpen ? <Modal title="EAUB CMS menu" id="admin-menu" drawer onClose={() => setMenuOpen(false)}
      footer={<div className="menu-account"><span className="muted">Signed in as</span><span className="menu-account__email">{email}</span>
        <button type="button" className="btn btn--secondary" onClick={onLogout} disabled={loggingOut}>{loggingOut ? "Logging out…" : "Logout"}</button></div>}>
      <Navigation onNavigate={() => setMenuOpen(false)} />
    </Modal> : null}
  </div>;
}
